import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import PopularIcon from '../../icons/homePage/popular'
import SupportIcon from '../../icons/homePage/support'
import QualityIcon from '../../icons/homePage/quality'
import UniqueIcon from '../../icons/homePage/unique'
import PhotoIcon from '../../icons/homePage/photo'
import VideoIcon from '../../icons/homePage/video'
import PricingIcon from '../../icons/homePage/pricing'
import GlassesIcon from '../../icons/homePage/glasses'
import ComputerIcon from '../../icons/homePage/computer'
import ImageIcon from '../../icons/homePage/image'
import TracksIcon from '../../icons/homePage/tracks'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import { IHomePageBlockComponent } from '../../../../typings/pageBlocks'
import ItemsSlideBlock from '../itemsSlideBlock/itemsSlideBlock'

import * as styles from './valuePropositionBlock.module.css'

interface ITiles {
  title: string
  description: string
  icon: string
}

interface IProps extends IHomePageBlockComponent {
  title: string
  tiles: ITiles[]
  data: IItem[]
}

const icons = new Map([
  ['popular', PopularIcon],
  ['support', SupportIcon],
  ['quality', QualityIcon],
  ['video', VideoIcon],
  ['pricing', PricingIcon],
  ['photo', PhotoIcon],
  ['unique', UniqueIcon],
  ['glasses', GlassesIcon],
  ['computer', ComputerIcon],
  ['image', ImageIcon],
  ['tracks', TracksIcon]
])

const reportValuePropositionBlockClick = (
  eventLabel: string,
  eventValue?: number
) => {
  reportBlockClick('Value Proposition', {
    dimension19: 'body',
    eventAction: 'click;link',
    eventLabel,
    eventValue
  })
}

const ValuePropositionBlock = ({ data, title, tiles, currentSite }: IProps) => {
  return (
    <ItemsSlideBlock
      currentSite={currentSite}
      title={title}
      data={data}
      headerAlign="right"
      hideSlideOnMobile
      onItemClick={(item, index) =>
        reportValuePropositionBlockClick(`${item.id}`, index)
      }
      testSelector="valuePropositionBlock"
    >
      <div className={styles.tilesArea}>
        {tiles.map((tile, index) => {
          const Icon = icons.get(tile.icon)
          return (
            <div className={styles.tile} key={index}>
              {Icon && (
                <div className={styles.tileIcon}>
                  <Icon width="48" height="48" />
                </div>
              )}
              <div className={styles.tileContent}>
                {tile.title && (
                  <h3 className={styles.tileTitle}>{tile.title}</h3>
                )}
                <div className={styles.tileDescription}>{tile.description}</div>
              </div>
            </div>
          )
        })}
      </div>
    </ItemsSlideBlock>
  )
}

export default ValuePropositionBlock
